var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkDropdown)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.outside),expression:"outside"}],staticClass:"ldc-dropdown"},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }